import { render } from "./AvatarsContent.vue?vue&type=template&id=60135a97&ts=true"
import script from "./AvatarsContent.vue?vue&type=script&lang=ts"
export * from "./AvatarsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__